"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = require("react");
var _useUniversalLayoutEffect = _interopRequireDefault(require("./useUniversalLayoutEffect"));
var _useResizeObserver = _interopRequireDefault(require("./useResizeObserver"));
var useResponsiveSizes = function useResponsiveSizes(callback, ref, _ref, containerBreakpoints) {
  var _ref$md = _ref.md,
    md = _ref$md === void 0 ? 600 : _ref$md,
    _ref$lg = _ref.lg,
    lg = _ref$lg === void 0 ? 1024 : _ref$lg,
    _ref$xl = _ref.xl,
    xl = _ref$xl === void 0 ? 1440 : _ref$xl,
    _ref$xxl = _ref.xxl,
    xxl = _ref$xxl === void 0 ? 1920 : _ref$xxl;
  var _useState = (0, _react.useState)(ref === null || ref === void 0 ? void 0 : ref.current),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    container = _useState2[0],
    setContainer = _useState2[1];
  var getSizeName = function getSizeName(size) {
    if (size < md) {
      return 'sm';
    }
    if (size >= md && size < lg) {
      return 'md';
    }
    if (size >= lg && size < xl) {
      return 'lg';
    }
    if (size >= xl && size < xxl) {
      return 'xl';
    }
    return 'xxl';
  };
  var handleResize = function handleResize(width) {
    if (container || width) {
      callback(getSizeName((container === null || container === void 0 ? void 0 : container.offsetWidth) || width));
    }
  };
  (0, _useResizeObserver.default)({
    onResize: function onResize(_ref2) {
      var width = _ref2.width;
      handleResize(width);
    },
    targetRef: ref,
    disconnect: !containerBreakpoints
  });
  (0, _react.useEffect)(function () {
    setContainer(ref === null || ref === void 0 ? void 0 : ref.current);
    handleResize();
  }, [ref === null || ref === void 0 ? void 0 : ref.current]);
  (0, _useUniversalLayoutEffect.default)(function () {
    handleResize();
  }, []);
  (0, _react.useEffect)(function () {
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });
};
var _default = exports.default = useResponsiveSizes;